import { Box, Typography } from "@mui/material";
import Grid from "@mui/material/Grid2";
import React from "react";
import { useTranslation } from "react-i18next";

const TextSection = () => {
  const { t } = useTranslation();
  return (
    <Grid size={{ xl: 12, sm: 12 }}>
      <Box
        sx={{
          alignContent: "center",
          textAlign: "center",
          justifyItems: "center",
          marginTop: "5%",
          marginBottom: "5%",
        }}
      >
        <Typography
          variant="h3"
          sx={{
            fontSize: "40px",
            fontWeight: "900",
            fontFamily: "Tajawal-Bold",
            color: "#2E2E2E",
          }}
        >
          {t("Simply put, prices that match your budget")}
        </Typography>
        <Typography
          variant="h3"
          mt={2}
          mb={5}
          sx={{
            fontSize: "20px",
            fontWeight: "400",
            fontFamily: "Tajawal-Regular",
            color: "#808080",
          }}
        >
          {t(
            "Enjoy the monthly or annual plan, with suitable features and functions, at prices that suit everyone."
          )}
        </Typography>
      </Box>
    </Grid>
  );
};
export default TextSection;
